import React from "react";

const S = { fill: "none", strokeLinecap: "round", strokeLinejoin: "round" };

export const Star = ({ className = "w-5 h-5", color = "#EF3C23", filled = true, style }) => (
  <svg viewBox="0 0 24 24" className={className} style={style} aria-hidden="true">
    <path d="M12 2.5l2.6 6.2 6.7.5-5.1 4.4 1.6 6.6L12 16.7l-5.8 3.5 1.6-6.6-5.1-4.4 6.7-.5z"
      fill={filled ? color : "none"} stroke="#24332C" strokeWidth="1.6" {...S} />
  </svg>
);

export const Sparkle = ({ className = "w-5 h-5", color = "#FFD966", style }) => (
  <svg viewBox="0 0 24 24" className={className} style={style} aria-hidden="true">
    <path d="M12 2c.6 4.8 2.4 7.4 8 8-5.6.6-7.4 3.2-8 8-.6-4.8-2.4-7.4-8-8 5.6-.6 7.4-3.2 8-8z"
      fill={color} stroke="#24332C" strokeWidth="1.4" {...S} />
  </svg>
);

export const Cloud = ({ className = "w-8 h-8", color = "#BAE4E9", style }) => (
  <svg viewBox="0 0 32 20" className={className} style={style} aria-hidden="true">
    <path d="M8 17a5 5 0 01-.6-9.97A7 7 0 0121 6.2 5.5 5.5 0 0124.5 17H8z"
      fill={color} stroke="#24332C" strokeWidth="1.5" {...S} />
  </svg>
);

export const Flower = ({ className = "w-5 h-5", color = "#F5CBDD", style }) => (
  <svg viewBox="0 0 24 24" className={className} style={style} aria-hidden="true">
    {[0, 60, 120, 180, 240, 300].map((a) => (
      <ellipse key={a} cx="12" cy="5.5" rx="2.6" ry="4" fill={color} stroke="#24332C" strokeWidth="1.2"
        transform={`rotate(${a} 12 12)`} />
    ))}
    <circle cx="12" cy="12" r="2.4" fill="#F9E498" stroke="#24332C" strokeWidth="1.2" />
  </svg>
);

export const Squiggle = ({ className = "w-16 h-4", color = "#35785B", style }) => (
  <svg viewBox="0 0 80 12" className={className} style={style} aria-hidden="true">
    <path d="M2 8c6-8 12-8 18 0s12 8 18 0 12-8 18 0 12 8 22 0" stroke={color} strokeWidth="2.4" {...S} />
  </svg>
);

export const CurvedArrow = ({ className = "w-10 h-10", color = "#35785B", style }) => (
  <svg viewBox="0 0 40 40" className={className} style={style} aria-hidden="true">
    <path d="M6 30c2-14 16-22 26-18" stroke={color} strokeWidth="2.4" {...S} />
    <path d="M26 8l7 3-3 7" stroke={color} strokeWidth="2.4" {...S} />
  </svg>
);

export const Bee = ({ className = "w-7 h-7", style }) => (
  <svg viewBox="0 0 32 32" className={className} style={style} aria-hidden="true">
    <ellipse cx="13" cy="9" rx="6" ry="4" fill="#BAE4E9" stroke="#24332C" strokeWidth="1.4" transform="rotate(-25 13 9)" />
    <ellipse cx="19" cy="17" rx="8" ry="6" fill="#F9E498" stroke="#24332C" strokeWidth="1.6" />
    <path d="M13 13.5c1 2.4 1 4.6 0 7M17 12.5c1.2 2.8 1.2 6.2 0 9" stroke="#24332C" strokeWidth="1.6" {...S} />
    <circle cx="25" cy="15" r="1.4" fill="#24332C" />
  </svg>
);

export const TrailDots = ({ className = "w-24 h-6", color = "#35785B", style }) => (
  <svg viewBox="0 0 120 20" className={className} style={style} aria-hidden="true">
    <path d="M3 15c14-10 26 8 40-4s26 8 40-4 26 8 34 0" stroke={color} strokeWidth="2" {...S} strokeDasharray="1 7" />
  </svg>
);

export const Pencil = ({ className = "w-6 h-6", color = "#DDD2F4", style }) => (
  <svg viewBox="0 0 24 24" className={className} style={style} aria-hidden="true">
    <rect x="9" y="3" width="6" height="15" rx="1.5" transform="rotate(35 12 12)" fill={color} stroke="#24332C" strokeWidth="1.4" />
    <path d="M7.2 18.8l1.4 3 2.6-2" fill="#EF3C23" stroke="#24332C" strokeWidth="1.4" {...S} />
  </svg>
);

export function Scallop({ color = "#C9DFCC", flip = false, className = "" }) {
  return (
    <svg viewBox="0 0 1440 40" preserveAspectRatio="none" className={`w-full h-8 block ${flip ? "rotate-180" : ""} ${className}`} aria-hidden="true">
      <path d="M0 40V22C24 8 48 8 72 22s48 14 72 0 48-14 72 0 48 14 72 0 48-14 72 0 48 14 72 0 48-14 72 0 48 14 72 0 48-14 72 0 48 14 72 0 48-14 72 0 48 14 72 0 48-14 72 0 48 14 72 0 48-14 72 0 48 14 72 0 48-14 72 0 48 14 72 0 48-14 72 0 48 14 72 0 48-14 72 0 48 14 72 0 48-14 72 0 48 14 72 0 48-14 72 0 48 14 72 0 48-14 72 0V40z" fill={color} />
    </svg>
  );
}
